import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PermissionContext } from 'hoc/withPermission';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  id: number;
  name: string;
};

const PraticalFieldCard = ({ id, name }: Props) => {
  const { hasPermission } = useContext(PermissionContext);

  return (
    <div className="card-100 card-body">
      <div className="d-flex justify-space-between">
        <p className="semi-bold brown text-underline">{name}</p>
        {hasPermission('academico.change_praticalfield') && (
          <Link to={`/campos-pratica/${id}/edit`}>
            <div className="w-40 h-100 d-flex justify-flex-end mt-2">
              <FontAwesomeIcon icon="edit" className="primary mr-2" />
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};

export default PraticalFieldCard;
